import React, { Component } from 'react'
import Header from '../../Components/header/index.jsx'
import Footer from '../../Components/Footer/index'
import { useParams } from 'react-router-dom'
import './index.scss'
import { ArrowRightOutlined } from '@ant-design/icons'
import Hardware from '../../home/component/Hardware/index'
class index extends Component {
  componentWillMount() {
    document.title = '高温温湿度_温湿度_智慧物联网_大数据平台_数字孪生_北京锐控自动化科技有限公司|硬件产品'
  }
  render() {
    return (
      <div>
        <Header></Header>
        <div className="hardwareProductContent">
          <div className="hardwareProductContent-title">
            <div className="hardwareProductContent-title-h1">硬件产品</div>
            <div className="hardwareProductContent-title-text">HARDWARE PRODUCTS</div>
          </div>
        </div>
        <div style={{ height: '1.485714rem ' }}></div>
        <Hardware titleIshow={false}></Hardware>
        <Footer></Footer>
      </div>
    )
  }
}

export default index
